import type { ReactNode } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "shared/components/Tooltip";
import { cx } from "shared/utils/classnames";

interface PermissionTooltipProps {
  tooltip?: string;
  className?: string;
  children: ReactNode;
}

export const PermissionTooltip = ({
  tooltip,
  className,
  children
}: PermissionTooltipProps) => {
  if (!tooltip) return children;

  return (
    <Tooltip placement="bottom-start" delay={{ open: 300 }}>
      <TooltipTrigger asChild>
        <span className={cx("inline-flex", className)}>{children}</span>
      </TooltipTrigger>
      <TooltipContent className="max-w-[260px] rounded-lg border border-alpha-40 bg-alpha-800 px-3 py-2 text-sm text-white z-[1000]">
        {tooltip}
      </TooltipContent>
    </Tooltip>
  );
};
